<template>
  <div class="sidebar">
    <nav class="category-nav">
      <div v-for="(category, index) in categories" 
         :key="index" 
         class="category-item"
         @mouseenter="showSubcategories(index)"
         @mouseleave="hideSubcategories">
        <a :href="category.link" class="category-link">
          <i :class="category.icon"></i>
          <span>{{ category.name }}</span>
          <i v-if="category.subcategories?.length" class="fas fa-chevron-right arrow"></i>
        </a>
        
        <!-- Subcategories Dropdown -->
        <div v-if="activeCategory === index && category.subcategories?.length" 
             class="subcategories-dropdown">
          <div class="subcategories-grid">
            <div v-for="(sub, subIndex) in category.subcategories" 
               :key="subIndex"
               class="subcategory-group">
              <a :href="sub.link" class="subcategory-link">
                {{ sub.name }}
              </a>
              <div v-if="sub.subsubcategories?.length" class="subsubcategory-list">
                <a v-for="(subsub, subsubIndex) in sub.subsubcategories"
                   :key="subsubIndex"
                   :href="subsub.link"
                   class="subsubcategory-link">
                  {{ subsub.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  }
})

const activeCategory = ref(null)

const showSubcategories = (index) => {
  activeCategory.value = index
}

const hideSubcategories = () => {
  activeCategory.value = null
}
</script>
